export default {
  state: {
    list: [],
    loading: false,
    currentPage: 0,
    perPage: 20,
    total: 0,
    sort: {
      column: 'created',
      isDesc: true
    },
    refreshList: false
  },
  mutations: {
    setTransactions (state, value) {
      value.forEach((x) => {
        x.isCollapsible = false
      })
      state.list = value
    },
    setLoading (state, value) { state.loading = value },
    setCurrentPage (state, value) { state.currentPage = value },
    setPerPage (state, value) { state.perPage = value },
    setTotal (state, value) { state.total = value },
    setSortColumn (state, value) { state.sort.column = value },
    setSortIsDesc (state, value) { state.sort.isDesc = value },
    setRefreshList (state, value) { state.refreshList = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/transactions/list.js